import {storeToRefs} from "pinia";
import {useSlidesStore} from "@/store";
import Papa from 'papaparse'

export default () => {

  interface FileTitles {
    title: string;
  }

  const slidesStore = useSlidesStore()
  const { valueModelId } = storeToRefs(slidesStore)

  const getFileTitles = async () => {
    const response = await fetch(`${import.meta.env.VITE_APP_ENV_SERVER}/lpi-service/file-service/get-folder-files/main/csv?vmId=${valueModelId.value}`, {
      method: 'GET',
    })
    const dataResponse = await response.json()

    const filteredData: FileTitles[] = dataResponse.data.filter((item: FileTitles) => item.title.includes('.csv'));
    return filteredData
  }

  const getFileSignedUrl = async (fileName: string) => {
    const response = await fetch(`${import.meta.env.VITE_APP_ENV_SERVER}/lpi-service/file-service/get-file/main/csv?vmId=${valueModelId.value}`, {
      method: 'POST',
      body: JSON.stringify({fileName: fileName})
    })
    return await response.text()
  }

  const getFileById = async (space, fileId) => {
    const response = await fetch(`${import.meta.env.VITE_APP_ENV_SERVER}/lpi-service/file-service/get-file-id/${space}/${fileId}`, {
      method: 'GET',
    })
    const data = await response.json()
    return data.slides
  }

  const downloadAndParseCsv = async (presignedUrl: string) => {
    let response
    await fetch(presignedUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`)
          }
          return response.text()
        })
        .then(csvData => {
          Papa.parse(csvData, {
            header: true, // Assumes the CSV has a header row
            dynamicTyping: true,
            complete: (result) => {
              response = result.data
            },
            error: (error) => {
              response = ''
              console.error('Papa Parse Error:', error.message)
            },
          })
        })
        .catch(error => {
          response = ''
          console.error('Fetch Error:', error)
        })

    return response
  }

  return {
    getFileTitles,
    getFileSignedUrl,
    getFileById,
    downloadAndParseCsv
  }
}
